const HSaude = () => import('../views/home.vue')
const EscMed = () => import('../views/EscalaMedica.vue')
const ImpMed = () => import('../views/ImportarMedicamentos.vue')

export default [
  { name: 'viewHSaude', path: '/saude', component: HSaude, meta: { acl: true } },
  { name: 'viewEscMed', path: '/saude/esala-medica', component: EscMed, meta: { acl: true } },
  { name: 'viewImpMed', path: '/saude/medicamentos', component: ImpMed, meta: { acl: true } },
]
